import { Route } from '@angular/router';
import { planGuard } from './guards/plan.guard';
import { paymentGuard } from './guards/payment.guard';
import { guestOnlyGuard } from './guards/guest-only.guard';

export const appRoutes: Route[] = [
  { path: '', redirectTo: '/purchase', pathMatch: 'full' }, // redirect to `purchase`
  {
    path: 'purchase',
    canActivate: [guestOnlyGuard],
    loadComponent: () =>
      import('./components/sign-up/sign-up.component').then(
        (m) => m.SignUpComponent,
      ),
  },
  {
    path: 'plan',
    canActivate: [guestOnlyGuard, planGuard],
    loadComponent: () =>
      import('./components/plan/plan.component').then((m) => m.PlanComponent),
  },
  {
    path: 'payment',
    canActivate: [guestOnlyGuard, paymentGuard],
    loadComponent: () =>
      import('./components/payment/payment.component').then(
        (m) => m.PaymentComponent,
      ),
  },
  { path: '**', redirectTo: '/purchase' },
];
